import React, { useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext.js';
import IDCard from './IDCard.jsx';
import { toPng } from 'html-to-image';

function UserDashboard() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const idCardRef = useRef(null);

  const handleDownload = async () => {
    if (idCardRef.current === null) {
      return;
    }
    try {
      const options = {
        cacheBust: true,
        fetchRequestCredentials: 'anonymous',
        backgroundColor: '#ffffff',
      };
      const dataUrl = await toPng(idCardRef.current, options);
      const link = document.createElement('a');
      link.href = dataUrl;
      link.download = `ABSSVSS-ID-Card-${user.memberId}.png`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (err) {
      console.error('Oops, something went wrong!', err);
      alert('Could not download the ID card. This may be due to a browser security issue. Please try again.');
    }
  };

  return (
    <div className="bg-white p-8 rounded-lg shadow-lg w-full max-w-4xl">
      <div className="flex flex-wrap justify-between items-center mb-6 gap-4">
        <h1 className="text-3xl font-bold text-brand-primary">Welcome, {user?.firstName}!</h1>
        <div className="flex items-center gap-4">
            <button onClick={() => navigate('/edit-profile')} className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded">
                Edit Your Profile
            </button>
            <button onClick={() => navigate('/change-password')} className="bg-gray-600 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded">
                Change Password
            </button>
            <button onClick={logout} className="bg-red-500 hover:bg-red-600 text-white font-bold py-2 px-4 rounded">
                Logout
            </button>
        </div>
      </div>
      
      <div className="flex flex-col md:flex-row gap-8 items-center md:items-start">
        <div className="md:w-1/2">
            <h2 className="text-2xl font-semibold text-gray-700 mb-4">Your Digital ID Card</h2>
            <p className="text-gray-600 mb-4">You can download your official membership ID card. The QR code links to your public profile for verification.</p>
            <button onClick={handleDownload} className="bg-brand-accent hover:bg-orange-500 text-white font-bold py-2 px-6 rounded">
                Download ID Card
            </button>
        </div>
        <div className="md:w-1/2 flex justify-center">
            <IDCard user={user} ref={idCardRef} />
        </div>
      </div>
    </div>
  );
}

export default UserDashboard;

